<template>
  <!-- 时段选择 -->
  <van-action-sheet v-model="times.show" title="选择预约时段">
    <div class="times" ref="timesRef">
      <van-empty description="暂无可选时段" v-if="!times.list.length" />
      <div class="content">
        <div class="item" v-for="(item, index) in times.list" :key="index">
          <div class="label">{{ item.name }}</div>
          <div class="value">
            <div
              class="itm"
              :class="{
                disabled: itm.disabled || itm.appointed,
                active: onTimeInRange(
                  formatTime(apptStartTime).getTime(),
                  formatTime(apptEndTime).getTime(),
                  itm.startTime,
                  itm.endTime
                ),
              }"
              v-for="(itm, idx) in item.times"
              :key="idx"
              @click="onTimeChange(itm)"
            >
              <span>{{ itm.start }}</span>
              <span>-</span>
              <span>{{ itm.end }}</span>
              <span v-if="itm.appointed">（已约）</span>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <van-button class="button" @click="times.show = false">返回</van-button>
        <van-button class="button" @click="onTimeConfirm">确定</van-button>
      </div>
    </div>
  </van-action-sheet>
</template>
<script>
import { formatTime } from "@/hooks/function";
export default {
  name: "reservation-times",
  components: {},
  props: {
    apptStartTime: {
      type: String,
      default: "",
    },
    apptEndTime: {
      type: String,
      default: "",
    },
    apptSelf: {
      type: Function,
      default: () => {},
    },
    interval: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      times: {
        show: false,
        list: [],
        appointed: "",
        appts: [],
      },
    };
  },
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {
    formatTime,
    onTimeInit(doctor, date) {
      this.times.appts = doctor.appts || [];
      this.times.show = true;
      this.$nextTick(() => {
        if (this.$refs.timesRef) {
          const selectors = this.$refs.timesRef.querySelectorAll(".item");
          selectors.forEach((item) => {
            const selector = item.querySelector(".itm:not(.disabled)");
            selector && selector.scrollIntoView();
          });
        }
      });
      const { workStartTime = "", workEndTime = "" } = doctor;
      this.times.list = this.onTimeFilter(date, workStartTime, workEndTime);
    },
    onTimeChange(row) {
      if (row.disabled || row.appointed) return false;
      this.$emit("update:apptStartTime", row.startTime);
      this.$emit("update:apptEndTime", row.endTime);
    },
    onTimeFilter(
      date,
      start,
      end,
      restStart = "11:30",
      restEnd = "13:00",
      max = "21:00"
    ) {
      let res = [];
      const restStartTime = formatTime(`${date} ${restStart}:00`);
      const restEndTime = formatTime(`${date} ${restEnd}:00`);
      const maxTime = formatTime(`${date} ${max}:00`);
      const startTime = formatTime(start);
      const endTime = formatTime(end);
      if (restStartTime.getTime() > startTime.getTime()) {
        const morning = this.onTimesCreate(
          date,
          startTime.format("HH:mm"),
          endTime.getTime() < restStartTime.getTime()
            ? endTime.format("HH:mm")
            : restStartTime.format("HH:mm")
        );
        if (morning.length) {
          res.push({
            name: "上午",
            type: "morning",
            times: morning,
          });
        }
        if (endTime.getTime() > restEndTime.getTime()) {
          const afternoon = this.onTimesCreate(
            date,
            restEndTime.format("HH:mm"),
            endTime.getTime() > maxTime.getTime()
              ? maxTime.format("HH:mm")
              : endTime.format("HH:mm")
          );
          if (afternoon.length) {
            res.push({
              name: "下午",
              type: "afternoon",
              times: afternoon,
            });
          }
        }
      } else if (startTime.getTime() < maxTime.getTime()) {
        const afternoon = this.onTimesCreate(
          date,
          startTime.getTime() > restEndTime.getTime()
            ? startTime.format("HH:mm")
            : restEndTime.format("HH:mm"),
          endTime.getTime() > maxTime.getTime()
            ? maxTime.format("HH:mm")
            : endTime.format("HH:mm")
        );
        if (afternoon.length) {
          res.push({
            name: "下午",
            type: "afternoon",
            times: afternoon,
          });
        }
      }
      return res;
    },
    onTimesCreate(date, start, end) {
      const minute = this.interval;
      const res = [];
      const endTime = formatTime(`${date} ${end}:00`).getTime();
      const nowTime = Date.now();
      let startTime = formatTime(`${date} ${start}:00`).getTime();
      while (startTime < endTime) {
        const duration = startTime + minute * 1000 * 60;
        const startDate = formatTime(startTime);
        const lastTime = duration <= endTime ? duration : endTime;
        const endDate = formatTime(lastTime);
        res.push({
          date,
          start: startDate.format("HH:mm"),
          end: endDate.format("HH:mm"),
          startTime: startDate.format("YYYY-MM-DD HH:mm:00"),
          endTime: endDate.format("YYYY-MM-DD HH:mm:00"),
          disabled:
            !this.onTimeAppointedSelf(startTime, lastTime) &&
            nowTime + 15 * 60 * 1000 > startTime,
          appointed: this.onTimeAppointed(startTime, lastTime),
        });
        startTime = duration;
      }
      return res;
    },
    onTimeAppointedSelf(startTime, endTime) {
      if (this.apptSelf) {
        return this.apptSelf(startTime, endTime);
      }
      return false;
    },
    onTimeAppointed(startTime, endTime) {
      if (this.times.appts.length) {
        if (this.onTimeAppointedSelf(startTime, endTime)) return false;
        return this.times.appts.some((row) =>
          this.onTimeInRange(
            startTime,
            endTime,
            row.apptStartTime,
            row.apptEndTime
          )
        );
      }
      return false;
    },
    onTimeInRange(startTime, endTime, apptStartTime, apptEndTime) {
      return (
        (formatTime(apptStartTime).getTime() >= startTime &&
          formatTime(apptStartTime).getTime() < endTime) ||
        (formatTime(apptEndTime).getTime() > startTime &&
          formatTime(apptEndTime).getTime() <= endTime)
      );
    },
    onTimeConfirm() {
      if (!this.apptStartTime) {
        this.$toast("请选择预约时段");
        return false;
      }
      if (this.times.show) this.times.show = false;
      this.$emit("confirm");
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";
.van-action-sheet {
  max-height: 100%;
  #{$deep} .van-action-sheet__header {
    font-weight: bold;
    text-align: left;
    padding-left: 20px;
  }
  .foot {
    @include flex(center, center);
    padding: 10px 15px;
    .button {
      font-size: 16px;
      border-radius: 25px;
      height: 48px;
      &::after {
        display: none;
      }
      &:first-child {
        background: #f2f2f2;
        width: 30%;
      }
      &:not(:first-child) {
        background: $color-primary;
        color: #fff;
        flex: 1;
        margin-left: 15px;
      }
      &.hover {
        opacity: 0.85;
      }
    }
  }
}
.times {
  height: 82vh;
  @include flex($dir: column);
  .content {
    flex: 1;
    @include flex();
    overflow: hidden;
    padding: 0 15px;
    .item {
      @include flex($dir: column);
      overflow: hidden;
      flex: 1;
      &:not(:first-child) {
        margin-left: 10px;
      }
      .label {
        padding: 9px;
        background: #f4f4f4;
        text-align: center;
        border-radius: 5px;
        margin-bottom: 7px;
      }
      .value {
        flex: 1;
        height: 100%;
        overflow-y: auto;
        .itm {
          padding: 12px;
          text-align: center;
          font-size: 18px;
          cursor: pointer;
          &.disabled {
            color: #ccc;
            cursor: not-allowed;
          }
          &.active {
            color: $color-primary;
            font-weight: bold;
            background: #edf0ff;
          }
        }
      }
    }
  }
}
</style>
